import { ReactNode } from "react";
import { cn } from "../private/utils.js";

const classes = {
  alert: `text-white bg-red-500 dark:border-gray-900 border-white`,
  info: `text-mono-800 dark:border-mono-700/50 dark:bg-mono-950 dark:text-mono-200`
};

export const Badge = ({
  count,
  className = "",
  action = `alert`,
  children
}: {
  count?: number;
  className?: string;
  action?: "alert" | "info";
  children?: ReactNode;
}) => {
  if (!count) return null;

  return (
    <span
      className={cn(
        `absolute top-0 left-full inline-flex p-1 items-center justify-center min-w-[1.5rem]  h-6 text-xs font-bold  border-2  rounded-full `,
        classes[action],
        className
      )}
    >
      {/* <span className="absolute inset-0 bg-red-500 animate-ping rounded-full z-1" /> */}
      {count || children}
    </span>
  );
};
